<template>
  <b-modal :id="idModal" :ref="idModal" size="xl" body-classes="p-0" @show=show @hide=hide>
    <b-form>
      <div>
        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Nombre"
              placeholder="Nombre"
              :disabled="esVisible"
              v-model="nombre"
            >
            </base-input>
          </b-col>
        </b-row>
      </div>
    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="guardacolegioCurso()"
        >
          Guardar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: "formColegioCurso",
  components: {},
  props: {
    datos: {
      default: { nombre: "", id: undefined },
    },
    idModal:{
      default:""
    }
  },
  data() {
    return {
      esVisible: false,
      nombre:"",
    };
  },
  methods: {
    show(){
      this.nombre = this.datos.nombre;
    },
    hide(){
      this.nombre = "";
    },
    guardacolegioCurso() {
      this.datos.nombre = this.nombre;
      this.$emit("guarda", this.datos);
    },
  },
  destroyed() {},
};
</script>
<style></style>
